const revenueReportTypes = {
    SET_REV_REPORT_SELECTED_FILTER: "SET_REV_REPORT_SELECTED_FILTER",
};
    
export default revenueReportTypes;
